export const conversationSummaryStyles = {
  root: "my-2 gap-0 overflow-hidden rounded-2xl border-border py-0 shadow-sm",
  header: "flex flex-col gap-2 px-4 pb-3 pt-4",
  titleRow: "flex items-center justify-between gap-2",
  titleGroup: "flex min-w-0 items-center gap-2",
  title: "min-w-0 truncate text-sm font-semibold leading-tight text-strong",
  metaRow: "flex items-center justify-between gap-2",
  // text-mid on the card: 7.56:1 light / 5.78:1 dark (WCAG AA needs 4.5:1).
  dates: "flex min-w-0 items-center gap-1 text-xs text-mid",
  // Decorative (aria-hidden), so it can sit lighter than the date text beside it.
  clockIcon: "h-3.5 w-3.5 shrink-0 text-subtle",
  datesText: "truncate",
  // On bg-muted, text-mid is 6.87:1 in light but only 4.06:1 in dark (mid and
  // muted-foreground are the same gray there), so dark steps up to foreground (8.33:1).
  countPill:
    "ml-auto shrink-0 rounded-full bg-muted px-2 py-0.5 text-xxs text-mid dark:text-foreground",
  partialBadge:
    "inline-flex shrink-0 items-center gap-1 rounded-full border border-warning-border bg-warning-bg px-2 py-0.5 text-2xs font-medium text-warning-strong",
  partialIcon: "h-3 w-3",
  body: "border-t border-border px-4 py-3",
};
